import {
  HttpClient,
  HttpErrorResponse,
  HttpParams,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, map, tap, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class MfaService {
  constructor(private http: HttpClient) {}

  generateSecret(): Observable<any>  {
    return this.http.get<any>(environment.apiUrl + '/mfa', {}).pipe(
      catchError(this.handleError),
      map((resData:any) => {
        let returnData:any = {
          'code':'',
          'qrImg':'',
        }
        if(resData._embedded.mfa.length>0){
          returnData = resData._embedded.mfa[0];
        }
        return returnData;
      })
    );
  }

  auth(code:number):Observable<any>{
    return this.http
      .post<any>(environment.apiUrl + "/mfa", {
        code
      })
      .pipe(
        catchError(this.handleError),
        tap((resData) => {
         // console.log(resData);
        })
      );
  }

  private handleError(errorRes: HttpErrorResponse) {
    // console.log(errorRes);
    let errorMessage =
      'An unknown error occurred.  If the problem persists please contact us.';
    if (!errorRes.statusText) {
      return throwError(errorMessage);
    }
   // console.log(errorRes);

    switch (errorRes.statusText) {
      case 'INVALID_CODE':
        errorMessage = 'The code provided was incorrect';
        break;
      case 'Unprocessable Entity':
        errorMessage = 'The data could not be processed.';
        break;
    }
    return throwError(errorMessage);
  }
}
